import React from 'react';
import Icon from '../../../components/AppIcon';

const SiteHealthCard = ({ status, uptime, lastChecked, securityScore }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'excellent':
        return 'text-success bg-success/10';
      case 'good':
        return 'text-primary bg-primary/10';
      case 'warning':
        return 'text-warning bg-warning/10';
      case 'critical':
        return 'text-error bg-error/10';
      default:
        return 'text-muted bg-muted';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'excellent':
        return 'CheckCircle2';
      case 'good':
        return 'CheckCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'critical':
        return 'XCircle';
      default:
        return 'HelpCircle';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 hover:shadow-md transition-shadow duration-300">
      <div className="flex items-start justify-between mb-4 md:mb-6">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">Site Health</h3>
          <p className="text-xs md:text-sm text-muted-foreground">Overall system status</p>
        </div>
        <div className={`p-2 md:p-3 rounded-lg ${getStatusColor(status)}`}>
          <Icon name={getStatusIcon(status)} size={20} className="md:w-6 md:h-6" />
        </div>
      </div>

      <div className="space-y-3 md:space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Icon name="Activity" size={16} className="text-muted-foreground" />
            <span className="text-xs md:text-sm text-foreground">Uptime</span>
          </div>
          <span className="text-sm md:text-base font-semibold text-success">{uptime}%</span>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Icon name="Shield" size={16} className="text-muted-foreground" />
            <span className="text-xs md:text-sm text-foreground">Security Score</span>
          </div>
          <span className="text-sm md:text-base font-semibold text-primary">{securityScore}/100</span>
        </div>

        <div className="pt-3 md:pt-4 border-t border-border">
          <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
            <Icon name="Clock" size={14} />
            <span>Last checked: {lastChecked}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteHealthCard;